import { render, staticRenderFns } from "./Kanit.vue?vue&type=template&id=dfa9827e"
import script from "./Kanit.vue?vue&type=script&lang=js"
export * from "./Kanit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports